module.exports = __webpack_public_path__ + "05_face.5f2b52d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/05_face.png
// module id = Hi5U
// module chunks = 0